import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import { COMPANY } from "@/lib/site-data";

const SECTIONS = [
  {
    title: "Éditeur du site",
    content: `${COMPANY.name} — Couvreur-zingueur. ${COMPANY.address}. Téléphone : ${COMPANY.phone}. Email : ${COMPANY.email}. Directeur de la publication : le gérant de ${COMPANY.name}.`,
  },
  {
    title: "Hébergement",
    content: "Ce site est hébergé sur une infrastructure cloud sécurisée. Les données sont sauvegardées régulièrement.",
  },
  {
    title: "Propriété intellectuelle",
    content: `L'ensemble des contenus du site (logo, textes, visuels, modèles 3D) est la propriété exclusive de ${COMPANY.name}. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.`,
  },
  {
    title: "Données personnelles (RGPD)",
    content: "Les informations transmises via le formulaire de devis (nom, email, téléphone, description du projet) sont utilisées uniquement pour traiter votre demande et vous recontacter. Elles ne sont ni vendues ni partagées avec des tiers. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression : écrivez-nous simplement par email.",
  },
  {
    title: "Cookies",
    content: "Ce site n'utilise aucun cookie publicitaire ni de suivi marketing. Seule une donnée de session technique mémorise l'affichage de l'écran d'accueil animé.",
  },
];

export default function Legal() {
  return (
    <div data-testid="legal-page" className="min-h-screen bg-[#0D0F12] text-slate-200">
      <div className="mx-auto max-w-3xl px-6 py-14">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center gap-4">
            <Logo size={48} />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-terra">{COMPANY.name}</p>
              <h1 className="font-serif text-3xl text-white sm:text-4xl">Mentions légales</h1>
            </div>
          </div>

          <div className="mt-12 space-y-8">
            {SECTIONS.map((s, i) => (
              <motion.section
                key={s.title}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 + i * 0.08, duration: 0.5 }}
                className="border-l-2 border-terra/40 pl-6"
              >
                <h2 className="font-serif text-xl text-slate-100">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.content}</p>
              </motion.section>
            ))}
          </div>

          <a
            href="/"
            data-testid="legal-back-link"
            className="mt-14 inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-slate-200 transition-colors hover:border-terra hover:text-terra"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour au site
          </a>
        </motion.div>
      </div>
    </div>
  );
}
